/* eslint-disable-next-line padded-blocks */
export const NOTIFICATIONS_DRAWER = 'NOTIFICATIONS_DRAWER';
export const NOTIFICATIONS_COUNT = '6 Unread';
export const UNREAD = 'Unread';
export const READ = 'Read';
export const DELETE = 'Delete';
export const LIST = 'List';
export const DETAIL = 'Detail';
export const NEW = 'New';
export const FETCH_NOTIFICATION_INTERVAL = 300000;
export const Notifications = [
    {
        PartnerID: '1234',
        UserID: null,
        MessageID: '39c8930b-aea5-419a-9931-a4c7ff5c01de',
        Type: null,
        Status: 'New',
        TimeStamp: 1719578538129,
        FriendlyMessage: null,
        TechnicalDetails: null,
    },
    {
        PartnerID: '1234',
        UserID: null,
        MessageID: '5588204d-1834-4c44-a66d-9b72aed58e47',
        Type: null,
        Status: 'New',
        TimeStamp: 1719491067832,
        FriendlyMessage: null,
        TechnicalDetails: null,
    },
    {
        PartnerID: '1234',
        UserID: '1238',
        MessageID: '5639',
        Type: 'Email Delivery Failure',
        Status: 'New',
        TimeStamp: 1672531700000,
        FriendlyMessage:
            'We encountered an issue while sending an email to <emailid>. It could be either due to the email address not being created by your email provider or the email address being added to the suppression list. To resolve this, remove the email address from the suppression list and attempt to resend the activation email after confirming that the email address exists.',
        TechnicalDetails: 'Wow, this is technical!',
    },
    {
        PartnerID: '1234',
        UserID: null,
        MessageID: '5675',
        Type: 'Email Delivery Failure2',
        Status: 'Read',
        TimeStamp: 0,
        FriendlyMessage: 'We encountered an issue while sending an email',
        TechnicalDetails: 'Wow, this is technica!',
    },
    {
        PartnerID: '1234',
        UserID: null,
        MessageID: '5678',
        Type: null,
        Status: 'Read',
        TimeStamp: 0,
        FriendlyMessage: null,
        TechnicalDetails: null,
    },
    {
        PartnerID: '1234',
        UserID: null,
        MessageID: '5679',
        Type: null,
        Status: 'Read',
        TimeStamp: 0,
        FriendlyMessage: null,
        TechnicalDetails: null,
    },
    {
        PartnerID: '1234',
        UserID: null,
        MessageID: 'dc57d75a-054b-4206-adc7-6fe46b3a8db9',
        Type: null,
        Status: 'New',
        TimeStamp: 1719578175466,
        FriendlyMessage: null,
        TechnicalDetails: null,
    },
];
